import { ApolloError, useMutation } from '@apollo/client'
import { EXCLUIR_ITEM } from '../data/excluir-item'
import { ITEMS_POR_PASTA_QUERY } from '../data/items-pasta-query'
import { ULTIMOS_MODIFICADOS_QUERY } from '../data/ultimo-modificados-query'
import { PASTAS_PERMISSAO_ESCRITA } from '../data/pastas-permissao-escrita'
import {
  ExcluirItemMutationMutation,
  ItemBiblioteca
} from '@/core/types/graphql'
import { t } from '@lingui/core/macro'
import { useConfirmModal } from '@/core/context/confirm-modal-context'
import { BUSCA_QUERY } from '../data/busca-query'

export const useRemover = ({ close }: { close: () => void }) => {
  const [excluirItemMutation] = useMutation<ExcluirItemMutationMutation>(
    EXCLUIR_ITEM,
    {
      refetchQueries: [
        ITEMS_POR_PASTA_QUERY,
        ULTIMOS_MODIFICADOS_QUERY,
        BUSCA_QUERY,
        PASTAS_PERMISSAO_ESCRITA
      ]
    }
  )

  const { askUser } = useConfirmModal()

  const handleRemover = async (itemsToRemove: ItemBiblioteca[]) => {
    const hasPasta = () => {
      if (itemsToRemove !== null && itemsToRemove.length > 0) {
        return (
          itemsToRemove.filter((item: ItemBiblioteca) => item.isPasta).length >
          0
        )
      }

      return false
    }

    askUser({
      onConfirm: async () => {
        try {
          await Promise.all(
            itemsToRemove.map((item: ItemBiblioteca) =>
              excluirItemMutation({
                variables: {
                  idItem: item.id
                }
              })
            )
          )

          close()
        } catch (error) {
          throw new Error((error as ApolloError).message)
        }
      },
      title: t`Você realmente deseja excluir?`,
      subtitle: hasPasta()
        ? t`Excluindo essa pasta você também irá excluir todos os itens filhos.`
        : undefined,
      confirmLabel: t`Excluir`,
      errorMessage: t`Erro ao remover`,
      successMessage: t`Remoção feita com sucesso!`
    })
  }

  return {
    handleRemover
  }
}
